module.exports = __webpack_public_path__ + "static/media/logo-light.ed667336.png";